<template>
  <div v-if="!data" class="centered-message-wrapper">
    <div class="centered-message">Select Customer in the Left</div>
  </div>
  <div v-else>
    <div class="actions">
        <sui-button compact color="red" @click="deleteCustomer" :loading="$store.state.admin.inProgress" :disabled="(data.Devices || []).length > 0">Delete Customer</sui-button>
    </div>
    <div class="details">
      <div class="def-divider">Customer</div>
      <div class="def-row" v-if="data"><div class="label">ID</div><div class="value">{{data.ID}}</div></div>
      <div class="def-row" v-if="data"><div class="label">UID</div><div class="value">{{data.UID}}</div></div>
      <div class="def-row" v-if="data"><div class="label">Name</div><div class="value">{{data.Name}}</div></div>
      <div class="def-row" v-if="data"><div class="label">Email</div><div class="value">{{data.Email}}</div></div>
      <div class="def-row" v-if="data"><div class="label">Billing ID</div><div class="value">{{data.BillingID}}</div></div>
      <div class="def-row" v-if="data"><div class="label">Created</div><div class="value">{{data.Created | formatCalendar}}</div></div>
      <!-- Clients -->
      <div class="def-divider">Clients ({{(data.Clients || []).length}})</div>
      <div class="subitem" v-for="client in data.Clients" :key="client.ID">
        <div class="def-divider sub">ID {{client.ID}} ({{client.DeviceName}}) {{client.ElevatedAccess ? '- Elevated Access' : ''}}</div>
        <div class="def-row"><div class="label">Device ID</div><div class="value">{{client.DeviceID}}</div></div>
        <div class="def-row"><div class="label">Last Login</div><div class="value">{{client.LastLogin | formatCalendar}}</div></div>
        <div class="def-row"><div class="label">Last Access</div><div class="value">{{client.LastAccess | formatCalendar}}</div></div>
      </div>
      <!-- Devices -->
      <div class="def-divider">Devices ({{(data.Devices || []).length}})</div>
      <div class="subitem" v-for="device in data.Devices" :key="device.ID">
        <div class="def-divider sub">{{device.ID}} {{device.Name !== device.ID ? '(' + device.Name + ')' : ''}}</div>
        <div class="def-row"><div class="label">ICC</div><div class="value">{{device.ICC}}</div></div>
        <div class="def-row"><div class="label">Last Update</div><div class="value">{{device.LastLocationUpdate | formatCalendar}}</div></div>
      </div>

      <!-- Error Placeholder -->
    <sui-message error v-if="$store.state.admin.deviceUpdateError !== ''">{{$store.state.admin.deviceUpdateError}}</sui-message>
    <!-- -->
    </div>
  </div>
</template>

<script>
    export default {
      name: "CustomerManagementDetails",
      props: ["data"],

      data: function() {
        return {}
      },
      watch: {
        data: function() {
        }
      },
      methods: {
        async deleteCustomer() {
          let confirmation = confirm(`Are you absolutely sure you want to delete ${this.data.Email}?`);
          if (confirmation) {
            await this.$store.dispatch('admin/deleteCustomer', this.data.ID)
            if (this.$store.state.admin.error === "") {
              this.$emit('refresh')
            }
          }

        },
      }
    }
</script>

<style scoped lang="less">
  .centered-message-wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    height: calc(100vh - 250pt);
    width: 350pt;
    .centered-message {
      align-self: center
    }
  }

  .def-divider {
    font-weight: bold;
    margin: 0;
    padding: 5pt 0pt 4pt 10pt;
    border-bottom: 1px solid #F0F0F0;
    background: #FAFAFA;
    box-sizing: border-box;
    height: 24pt;
    &.sub {
      background: transparent;
      padding-left: 10pt;
      color: darkslateblue;
    }
  }
  .def-row {
    box-sizing: border-box;
    display: flex;
    padding: 5pt 0pt 5pt 15pt;
    min-height: 24pt;
    .label {
      width: 100pt;
    }
    .value {
      flex: 1;
    }
    &.with-top-margin {
      margin-top: 5pt;
    }
  }
  .actions {
    display: flex;
    padding: 5pt 5pt;
    background: #F0F0F0;
    .left {
      text-align: left;
    }
    .right {
      text-align: right;
    }
    &.title {
      background: transparent;
      margin: 0;
      padding: 0 0 0 10pt;
    }
  }
  .subitem {
    padding: 0pt 10pt;
    zoom: 90%;
  }

</style>
